const UserPreferenceService = require('./user-preference.service');

require('angular')
    .module('wowApp.common')
    .service('UserPreferenceService', UserPreferenceService);



// WEBPACK FOOTER //
// ./src/common/userpreference/index.js